/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';
import { TYPE_COMPONENT_BY_TYPE_ACTE } from '@/constants';

import InformationsDefunt from './InformationsDefunt';

/** Étape « Défunt » de l'acte de décès, entre l'acte et les parents du défunt. */
const StepDefunt = () => {
  const { data, onChange, errors, selectedTypeActe } =
    React.useContext(AssistantContext);

  /** Tranche d'erreurs propre à cette étape (clés = `name` des champs) */
  const errorsStep = errors?.[Steps.Defunt] ?? {};

  const typeComponent = selectedTypeActe
    ? TYPE_COMPONENT_BY_TYPE_ACTE[selectedTypeActe]
    : undefined;

  return (
    <div
      className="assistant-step-defunt"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsDefunt
        data={data}
        errors={errorsStep}
        onChange={onChange}
        typeComponent={typeComponent}
      />
    </div>
  );
};

export default StepDefunt;
